import DashboardLayout from "../layouts/DashboardLayout.vue";
import NotFound from "@/pages/NotFoundPage";
import { ROLES } from "../helpers/commons.helpers";
import teamsRouters from "../modules/teams/router/team.routers";
import supplierRouters from "../modules/suppliers/router/supplier.routers";
import customerRouters from "../modules/customers/router/customer.routers";
import rateRouters from "../modules/rates/router/rate.routers";
import areaRouters from "../modules/areas/router/area.routers";
import partnerRouters from "../modules/partners/router/partner.routers";
import reservationRouters from "../modules/reservations/router/reservation.routers";
import experienceRouters from "../modules/experiences/router/experience.routers";
import destinationRouter from "../modules/destinations/router/destination.router";
import dashboardRouters from "../modules/metrics/router/metric.routers";
import authRouters from "@/pages/auth/router/auth.routers";
import profileRouters from "@/user/router/profile.routers";
import notificationRouters from "../modules/notifications/router/notification.routers";
import toolRouters from "../modules/tools/router/tool.routers";
import vehicleRouters from "../modules/vehicles/router/vehicle.routers";
import resellerRouters from "../modules/resellers/router/resellers.routers";

/**
 * Application routes configuration for Vue Router.
 *
 * Each entry in the `routes` array follows Vue Router's RouteConfig shape
 * and may include a `meta` object with the following properties:
 *
 * @typedef {Object} RouteMeta
 * @property {boolean} [requiresAuth=false] - When true the route requires an authenticated session.
 * @property {Array<string>} [roles=[]] - Array of role identifiers allowed to access the route.
 *
 * @typedef {import('vue-router').RouteConfig} RouteConfig
 *
 * @type {Array<RouteConfig>}
 * @description
 * The top-level `routes` array includes application routes as well as
 * grouped child routes for the authenticated layout. Routes that redirect
 * unauthenticated users set `meta.requiresAuth` to true and optionally
 * provide `meta.roles` to restrict access by role.
 */
const routes = [
  {
    path: "/",
    redirect: "/signin",
    name: "home",
    meta: {
      requiresAuth: false,
      roles: []
    }
  },
  ...authRouters,
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/reservations",
    name: "DashboardLayout",
    meta: {
      requiresAuth: true,
      roles: [
        ROLES.SUPER_ADMIN,
        ROLES.ADMIN,
        ROLES.MANAGER,
        ROLES.USER,
        ROLES.SUPPORT
      ]
    },
    children: [
      ...dashboardRouters,
      ...reservationRouters,
      ...customerRouters,
      ...supplierRouters,
      ...destinationRouter,
      ...rateRouters,
      ...areaRouters,
      ...profileRouters,
      ...vehicleRouters,
      ...teamsRouters,
      ...experienceRouters,
      ...partnerRouters,
      ...notificationRouters,
      ...toolRouters,
      ...resellerRouters,
    ],
  },
  {
    path: "*",
    component: NotFound
  }
];

/**
 * Default export: routes configuration used to create the VueRouter instance.
 *
 * @module routes
 * @returns {Array<RouteConfig>} Array of route definitions for the application.
 */
export default routes;
